import { useCookies } from 'react-cookie'
import { useAuthSessionStore } from 'Store/AuthSession'
import { shallow } from 'zustand/shallow'

const CHAT_URL = process.env.REACT_APP_CHAT_URL

export const useKumopackChat = () => {
	const [cookies] = useCookies(['kumopack-supplier-access-token'])
	const accessToken = cookies['kumopack-supplier-access-token']
	const sesssionAccessToken = useAuthSessionStore(state => state.accessToken, shallow)

	const chatBuyer = () => {
		window.open(
			`${CHAT_URL}/auth/buyer/${accessToken ?? sesssionAccessToken}`,
			'_blank',
			'rel=noopener noreferrer'
		)
	}

	const chatSupplier = () => {
		window.open(
			`${CHAT_URL}/auth/supplier/${accessToken ?? sesssionAccessToken}`,
			'_blank',
			'rel=noopener noreferrer'
		)
	}

	const chatAdmin = () => {
		window.open(
			`${CHAT_URL}/auth/admin/${accessToken ?? sesssionAccessToken}`,
			'_blank',
			'rel=noopener noreferrer'
		)
	}

	const chatBuyerToSupplier = (supplierUUID: string) => {
		window.open(
			`${CHAT_URL}/auth/buyer/${
				accessToken ?? sesssionAccessToken
			}?to=${supplierUUID}&type=supplier`,
			'_blank',
			'rel=noopener noreferrer'
		)
	}

	const chatSupplierToBuyer = (buyerUUID: string) => {
		window.open(
			`${CHAT_URL}/auth/supplier/${accessToken ?? sesssionAccessToken}?to=${buyerUUID}&type=buyer`,
			'_blank',
			'rel=noopener noreferrer'
		)
	}

	const chatAdminToBuyer = (buyerUUID: string) => {
		window.open(
			`${CHAT_URL}/auth/admin/${accessToken ?? sesssionAccessToken}?to=${buyerUUID}&type=buyer`,
			'_blank',
			'rel=noopener noreferrer'
		)
	}

	const chatAdminToSupplier = (supplierUUID: string) => {
		window.open(
			`${CHAT_URL}/auth/admin/${
				accessToken ?? sesssionAccessToken
			}?to=${supplierUUID}&type=supplier`,
			'_blank',
			'rel=noopener noreferrer'
		)
	}

	return {
		chatBuyer,
		chatSupplier,
		chatAdmin,
		chatBuyerToSupplier,
		chatSupplierToBuyer,
		chatAdminToBuyer,
		chatAdminToSupplier,
	}
}
